export default {
	productsDetailed(state, getters, rootState, rootGetters){	
    let isLogin = rootGetters['user/isLogin'];
		let array = state.products.map(pr => {
			// let { title, price, price_ro, image_thumbnail, weight_packaging } = rootGetters['shopCards/getOne'](pr.id);
			let fullPr = rootGetters[ isLogin ? 'shopCards/getOne' : 'shopCards/getOneSpecialistPr'](pr.id);
			return {
				...pr,
        ...fullPr
			}
		});
    return array;
	},
	totalSum(state, getters){
		return getters.productsDetailed.reduce((total, pr) => {
			return total + pr.price * pr.cnt;
		}, 0);
	},
	totalSumRo(state, getters){
		return getters.productsDetailed.reduce((total, pr) => {
			return total + pr.price_ro * pr.cnt;
		}, 0);
	},
	totalSumRu(state, getters){
		return getters.productsDetailed.reduce((total, pr) =>{
			return total + pr.price_ru * pr.cnt;
		}, 0);
	},
	totalCnt: state => state.products.length,
	inProccess: state => id => !state.loaded || state.proccessId.includes(id),
	canAdd: (state, getters) => id => state.loaded && !getters.inCart(id) && !getters.inProccess(id),
	canUpdate: (state, getters) => id => state.loaded && getters.inCart(id) && !getters.inProccess(id),
	inCart: (state, getters) => id => getters.index(id) !== -1,
	index: state => id => state.products.findIndex(pr => pr.id === id),
	item: (state, getters) => id => {
		let ind = getters.index(id);
		return ind === -1 ? null : state.products[ind];
	},
	itemCnt: (state, getters) => id => getters.item(id).cnt,
  products: (state) => state.products,
}